import type GameObject from "./game-object";
import type Transform from "./transform";
import { HideInInspector } from "@flint/shared/metadata";
import { NonSerialized } from "@flint/shared/metadata";

export default abstract class Component {
    /**
     * The GameObject that owns this component.
     */
    @NonSerialized
    @HideInInspector
    public gameObject!: GameObject;

    /**
     * Shortcut to the parent GameObject's Transform component.
     */
    public get transform(): Transform {
        return this.gameObject.transform;
    }

    /**
     * Called once when this component is attached to a GameObject.
     */
    public attach(): void { }

    /**
     * Called once when the game starts or when the component is added during the game.
     * 
     * If added after the game has started, this method will be called immediately after {@link attach}.
     */
    public start(): void { }

    /**
     * Called every frame after {@link start}.
     */
    public update(): void { }

    /**
     * Called when this component is detached from its GameObject.
     * 
     * Use this method to unregister from systems or temporarily stop updates/rendering.
     */
    public detach(): void { }

    /**
     * Called when this component is permanently removed from its GameObject.
     * 
     * Use this method to clean up internal state, unregister from systems, and release any resources.
     * 
     * After {@link destroy} is called, the component
     * should not be reused or reattached.
     */
    public destroy(): void {
        (this.gameObject as GameObject | undefined) = undefined;
    }
}
